import api from "./Api";

class AjudaModuloCategoriaService {
  GetAjudaModuloCategoria(payload) {
    return api.get("/v1/ajudaModuloCategoria/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAjudaModuloCategoria(payload) {
    return api.post("/v1/ajudaModuloCategoria/", payload).then((response) => {
      return response.data;
    });
  }

  PutAjudaModuloCategoria(payload) {
    return api.put("/v1/ajudaModuloCategoria/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAjudaModuloCategoria(payload) {
    return api
      .delete("/v1/ajudaModuloCategoria/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetAjudaModuloCategoriaOData(payload) {
    return api.get("/OData/AjudaModuloCategoria" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new AjudaModuloCategoriaService();
